import { SideBarItemData } from '@/components/ui/SideBarItem/SideBarItem';
import { AdminBereich, BEREICH_JE_SIDEBAR_PFAD } from '@/constants/bereiche';

/**
 * Sidebar der Rolle `unteradmin` (Entscheid Alex 16.10.2026 20:42): die
 * SA-Liste minus ausgeschaltete Bereiche — und ohne Eintraege, die nur die
 * echte Rolle `sa` sieht (`nurEchterSA`, z. B. API-Schluessel, Decision #252 H).
 */
export const unteradminSidebar = (
  items: SideBarItemData[],
  hatBereich: (bereich: AdminBereich) => boolean,
): SideBarItemData[] =>
  items.filter((item) => {
    if (item.nurEchterSA) return false;
    const bereich = BEREICH_JE_SIDEBAR_PFAD[item.path];
    return bereich === undefined || hatBereich(bereich);
  });
